define( function() {

"use strict";

return /^--/;

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/css/var/rcustomProp.js
// module id = 159
// module chunks = 0